import { TAssignedPin } from '@/services/aedifion/resources/project/responseTypes'

export const getPinsDatapointByAlphanumericId = (pins: TAssignedPin[], alphanumeric_id: string): null|string => {
  const pin: TAssignedPin|undefined = pins.find((pin: TAssignedPin) => pin.alphanumeric_id === alphanumeric_id)
  if (pin && pin.dataPointID) return pin.dataPointID
  return null
}
